import { EBuildingCraneType } from '../../../../json_query';
import { changeBuildingCrane } from '../../../state/advanced/building_crane';
import { getMultiSelectParam } from './abstract_params/multi_select_param';

export const BuildingCrane = getMultiSelectParam<EBuildingCraneType>(
  'Кран',
  [
    { title: 'Мостовой кран', value: EBuildingCraneType.Overhead },
    { title: 'Кран-балка', value: EBuildingCraneType.Beam },
    { title: 'Ж/д кран', value: EBuildingCraneType.Railway },
    { title: 'Козловой кран', value: EBuildingCraneType.Goat },
  ],
  'building_cranage_types_type',
  changeBuildingCrane,
);
